import React from "react";
import Icon from "../Icons";

interface SearchBarProps {
  placeholder?: string;
  onSearch: (searchTerm: string) => void;
  value?: string;  // Make it required, not optional
  onClick?: () => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const SearchBar = ({
  onSearch,
  placeholder,
  value,
  onClick,
  onKeyDown,
}: SearchBarProps) => {
  // No local state - component is fully controlled by parent

  const handleSearchClick = () => {
    onClick?.();
  };

  return (
    <div className="relative w-full">
      <div className="flex w-full overflow-hidden">
        <input
          type="text"
          placeholder={`${placeholder ? placeholder : "Search..."}`}
          className="flex-grow text-[#F4F5F7] pl-10 pr-4 py-[7px] bg-[#2E4051] rounded-md focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564]"
          value={value}  // Use prop directly
          onChange={(e) => onSearch(e.target.value)}  // Update parent on every keystroke
          onKeyDown={onKeyDown}
        />
        <span
          className="text-[#008564] absolute left-2 top-1/2 transform -translate-y-1/2 hover:font-semibold"
          onClick={handleSearchClick}
        >
          <Icon name="ic-search" className="w-5 h-5" />
        </span>
        {value.trim() !== "" && (
          <span
            className="text-[#008564] absolute right-2 top-1/2 transform -translate-y-1/2 hover:font-semibold cursor-pointer"
            onClick={() => {
              onSearch("");  
            }}
          >
            <Icon name="ic-close" className="w-4 h-4" />
          </span>
        )}
      </div>
    </div>
  );
};

export default SearchBar;